import { Pageable } from "./pageable.model";
import { PlainAccomodation } from "./plain-accomodation.model";
import { Sort } from "./sort.model";

export class  ResponsePaginationTable{

    constructor(
           public content?: PlainAccomodation[],
           public pageable?: Pageable,
           public last?: boolean,
           public totalElements?: number,
           public totalPages?: number,
           public size?: number,
           public number?: number,
           public sort?: Sort,
           public first?:boolean,
           public numberOfElements?: number,
           public empty?: boolean
        ) {}
}